<template>
  <div class="footer-wrapper">
    <div class="footer">
      <!-- 主要内容区域 -->
      <div class="footer-content">
        <!-- 左侧：公司信息 -->
        <div class="footer-left">
          <div class="company-logo">
            <img src="../assets/images/logo-footer.png" alt="朗云物联" />
          </div>
          <div class="company-desc">
            广州佛朗斯股份有限公司全资子公司，专注于叉车智慧安全领域。让每一台叉车都安全，让每一个管理者都省心
          </div>
        </div>

        <!-- 中间：产品中心 -->
        <div class="footer-center">
          <div class="footer-column">
            <h4>产品中心</h4>
            <ul>
              <li><a href="#">智慧管理平台</a></li>
              <li><a href="#">叉车主动安全防护系统</a></li>
              <li><a href="#">叉车车队管理系统</a></li>
              <li><a href="#">叉车影像监控系统</a></li>
              <li><a href="#">叉车安全预警系列</a></li>
              <li><a href="#">叉车智能产品配件</a></li>
            </ul>
          </div>
          <!-- <div class="footer-column">
            <h4>&nbsp;</h4>
            <ul>
              <li><a href="#">F4智慧终端</a></li>
              <li><a href="#">F4智慧终端</a></li>
              <li><a href="#">F4智慧终端</a></li>
              <li><a href="#">F4智慧终端</a></li>
              <li><a href="#">F4智慧终端</a></li>
              <li><a href="#">F4智慧终端</a></li>
            </ul>
          </div> -->
          <div class="footer-column">
            <h4>关于朗云</h4>
            <ul>
              <li><a href="#">公司简介</a></li>
              <li><a href="#">客户案例</a></li>
              <li><a href="#">新闻动态</a></li>
              <li><a href="#">联系我们</a></li>
            </ul>
          </div>

          <div class="footer-column contact-info">
            <h4>联系方式</h4>
            <div class="contact-item">
              <span class="label">0551-58958652</span>
              <span class="desc">公司电话</span>
            </div>
            <div class="contact-item">
              <span class="label">langyun@langyuniot.com</span>
              <span class="desc">电子邮箱</span>
            </div>
            <div class="contact-item">
              <span class="label">安徽省合肥市肥西县蓬莱路3476号行政楼4楼</span>
              <span class="desc">公司地址</span>
            </div>
          </div>
        </div>

        <!-- 右侧：关于朗云 + 联系方式 -->
        <!-- <div class="footer-right">
          <div class="footer-column contact-info">
            <h4>联系方式</h4>
            <div class="contact-item">
              <span class="label">0551-58958652</span>
              <span class="desc">公司电话</span>
            </div>
            <div class="contact-item">
              <span class="label">langyun@langyuniot.com</span>
              <span class="desc">电子邮箱</span>
            </div>
            <div class="contact-item">
              <span class="label">安徽省合肥市肥西县蓬莱路3476号行政楼4楼</span>
              <span class="desc">公司地址</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- 底部版权信息 -->
      <div class="footer-bottom">
        <div class="copyright">© 2026 合肥朗云物联科技有限公司 All Rights Reserved</div>
        <div class="beian" @click="jump">皖ICP备20002469号-1</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    jump() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  }
}
</script>

<style lang='less' scoped>
.footer-wrapper {
  width: 100%;
  background: #001B35;
  padding: 60px 0 30px;
}

.footer {
  width: 80%;
  margin: 0 auto;

  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    // 左侧：公司信息
    .footer-left {
      // flex: 1;
      max-width: 350px;

      .company-logo {
        margin-bottom: 20px;

        img {
          height: 50px;
          object-fit: contain;
        }
      }

      .company-desc {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.8;
      }
    }

    // 中间：产品中心
    .footer-center {
      display: flex;
      gap: 150px;
      flex: 1;
      justify-content: center;
      padding-left: 100px;

      .footer-column {
        h4 {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 20px;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 12px;

            a {
              font-size: 16px;
              color: rgba(255, 255, 255, 0.7);
              text-decoration: none;
              transition: color 0.3s ease;

              &:hover {
                color: #fff;
              }
            }
          }
        }

        &.contact-info {
          .contact-item {
            margin-bottom: 15px;

            .label {
              display: block;
              font-size: 16px;
              color: #fff;
              margin-bottom: 5px;
            }

            .desc {
              display: block;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }
    }

    // 右侧：关于朗云 + 联系方式
    .footer-right {
      display: flex;
      gap: 60px;
      flex: 1;
      justify-content: flex-end;

      .footer-column {
        h4 {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 20px;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            margin-bottom: 12px;

            a {
              font-size: 16px;
              color: rgba(255, 255, 255, 0.7);
              text-decoration: none;
              transition: color 0.3s ease;

              &:hover {
                color: #fff;
              }
            }
          }
        }

        &.contact-info {
          .contact-item {
            margin-bottom: 15px;

            .label {
              display: block;
              font-size: 16px;
              color: #fff;
              margin-bottom: 5px;
            }

            .desc {
              display: block;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }
    }
  }

  // 底部版权信息
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;

    .copyright {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
    }

    .beian {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue